import { useLocalization } from '@/data/Localization';
import { Typography } from '@mui/material';
import { FC } from 'react';
import {
	QUANTITY_AVAILABLE_PLUS_10,
	QUANTITY_AVAILABLE_PLUS_999,
} from 'shared/custom/constants/commonConstants';
import { deliveryMethodSelectorSX } from '../styles/deliveryMethodSelector';

type Props = {
	availableQuantity: number;
	alignBottom?: boolean;
};

export const DeliveryStockCounter: FC<Props> = ({ availableQuantity, alignBottom }) => {
	const { Availability, DeliveryMethodSelector: labels } = useLocalization('HDMProductDetail');

	const isLow = availableQuantity < QUANTITY_AVAILABLE_PLUS_10;
	const text =
		availableQuantity > QUANTITY_AVAILABLE_PLUS_999
			? labels.StockHigh.t()
			: isLow
			? `${Availability.labels.just.t()}${Availability.labels.availableQuantityInventory.t({
					n: availableQuantity,
					count: availableQuantity,
			  })}`
			: Availability.labels.availableQuantityInventory.t({ n: availableQuantity, count: availableQuantity });

	return (
		<Typography
			variant="bodyBaseline"
			component="div"
			color={isLow ? 'warning.dark' : 'success.main'}
			className={`delivery-selector__stock${isLow ? ' delivery-selector__stock--low' : ''}`}
			sx={
				alignBottom
					? deliveryMethodSelectorSX.stockAlignBottom
					: deliveryMethodSelectorSX.spacing
			}
		>
			{text}
		</Typography>
	);
};
